import { FC, memo } from 'react';

import GenericLayout from '../components/generic-layout/GenericLayout';
import { H2 } from '../components/heading/Hx';
import Paragraph from '../components/paragraph/Paragraph';
import NoPageImageSection from '../components/section/NoPageImageSection';

const NotFound: FC = () => (
  <GenericLayout title='Seite nicht gefunden'>
    <NoPageImageSection>
      <H2 center>404 - Seite nicht gefunden</H2>
      <Paragraph center>Diese Seite existiert nicht mehr oder wurde verschoben.</Paragraph>
    </NoPageImageSection>
  </GenericLayout>
);

export default memo(NotFound);
